import React from 'react';
import './../../../Styles/Main/RentalPage/RentalOrderProcessed.scss';
import Scrollbars from 'rc-scrollbars';
import SwiperIcon from '../../../UI/swipericon/SwiperIcon';
import RentalOrderedBike from './RentalOrderedBike';
import MyButton from '../../../UI/button/MyButton';
import { BrowserRouter as Router, Routes, Route, Link, RouterProvider} from 'react-router-dom';
import { SelectedBike } from '../../../Constant/context';
import { useContext } from 'react';
import { aluminiumBikes, carbonBikes, cityBikes, mtbBikes, bikesBrend, bikesFrameSize, rentalRequestRoute } from './../../../Constant/index';

function RentalOrderProcessed() {

   const {selectedDateGlobal, setSelectedDateGlobal, selectedBikeGlobal, arrayOfBikes, setArrayOfBikes, orderedDateGlobal, setOrderedDateGlobal } = useContext(SelectedBike)

   const clearSelection = () => {

      makeOrder();

      setArrayOfBikes([]);
      for (let item in aluminiumBikes) {
         if (aluminiumBikes[item].state === true) aluminiumBikes[item].state = false;
      }
      for (let item in carbonBikes) {
         if (carbonBikes[item].state === true) carbonBikes[item].state = false;
      }
      for (let item in cityBikes) {
         if (cityBikes[item].state === true) cityBikes[item].state = false;
      }
      for (let item in mtbBikes) {
         if (mtbBikes[item].state === true) mtbBikes[item].state = false;
      }
   }

   const makeOrder = () => {
      setOrderedDateGlobal([...orderedDateGlobal, [selectedDateGlobal, arrayOfBikes]])
      let globalDate = { ...selectedDateGlobal }
      globalDate.startDate = 'YYYY.MM.DD';
      globalDate.finishDate = 'YYYY.MM.DD';
      globalDate.amountDays = '0';
      setSelectedDateGlobal(globalDate)
   }

   return (
      <div className='rentalOrder__body'>
         <div className="rentalOrder__date">
            <div className="rentalOrder__column">
               <div className="rentalOrder__signature signature">Type of rent</div>
               <div className="rentalOrder__data text">{ selectedDateGlobal['typeRent'] }</div>
            </div>
            <div className="rentalOrder__column">
               <div className="rentalOrder__signature signature">Start date</div>
               <div className="rentalOrder__data text">{ selectedDateGlobal['startDate'] }</div>
            </div>
            <div className="rentalOrder__column">
               <div className="rentalOrder__signature signature">Finish date</div>
               <div className="rentalOrder__data text">{ selectedDateGlobal['finishDate'] }</div>
            </div>
            <div className="rentalOrder__column">
               <div className="rentalOrder__signature signature">Delivery</div>
               <div className="rentalOrder__data text">{ selectedDateGlobal['delivery'] }</div>
            </div>
            <div className="rentalOrder__column">
               <div className="rentalOrder__signature signature">Payment</div>
               <div className="rentalOrder__data text">{ selectedDateGlobal['payment'] }</div>
            </div>
         </div>
         <div className="rentalOrder__swipe">
            <SwiperIcon/>
         </div>
         <Scrollbars style={{ width: '100%', height: (60*arrayOfBikes.length)+100 }}>
            <div className="rentalOrder__request-info">
               
               <div className="rentalOrder__item-title">
                  <div className="rentalOrder__columnName signature">Bike name</div>
                  <div className="rentalOrder__columnName signature">Price</div>
               </div>
               {arrayOfBikes.map((item, index) => (
                  <div
                     key={index}
                     className="rentalOrder__item"
                  >
                     <RentalOrderedBike
                        name={item['name']}
                        price={item['price']}
                        image={item['picture']}
                     />
                  </div>
               ))}
            </div>
         </Scrollbars>
         <div className="rentalOrder__summary">
            <div className="rentalOrder__cashSum">
               <div className="rentalOrder__titleDelivery rentalOrder__cashItem signature">Delivery:</div>
               <div className="rentalOrder__titleSum rentalOrder__cashItem signature">Total:</div>
               <div className="rentalOrder__costDelivery rentalOrder__cashItem color-text">0 usd</div>
               <div className="rentalOrder__costSum rentalOrder__cashItem color-text">{ `${selectedDateGlobal['sumPrice']} usd` }</div>
            </div>
         </div>
         <div className="rentalOrder__buttons">
            <div className="rentalOrder__back">
               <Link to='/rental'>
                  <MyButton
                     style={{ fontSize: '20px', fontWeight: '700' }}
                     onClick={clearSelection}
                  >Back to bikes
                  </MyButton>
               </Link>
            </div>
         </div>
      </div>
   );
}
export default RentalOrderProcessed;


